import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

interface HighchartsWrapperProps {
  options: Highcharts.Options
  containerProps?: React.HTMLAttributes<HTMLDivElement>
}

const HighchartsWrapper: React.FC<HighchartsWrapperProps> = ({
  options,
  containerProps,
}) => {
  return (
    <div {...containerProps}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  )
}

export default HighchartsWrapper
